import { render } from "./Hero.vue?vue&type=template&id=52a7c19e"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Hero.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52a7c19e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52a7c19e', __exports__)) {
    api.reload('52a7c19e', __exports__)
  }
  
  module.hot.accept("./Hero.vue?vue&type=template&id=52a7c19e", () => {
    api.rerender('52a7c19e', render)
  })

}


export default __exports__